import { DataSource, Label, Layout, Panel, Table } from "@mcleod/components";

export abstract class AutogenLayoutSalesCallMultiSelectErrorSlideout extends Layout {
    labelFailed: Label;
    labelFailedCount: Label;
    panelFailed: Panel;
    sourceSalesCallRecord: DataSource;
    tableFailed: Table;
}
